import { ApplicationState } from "../applicationState";

export const routeIdSelector = (state: ApplicationState): string => state.router.params!.accessGroupId!;

export const pathSelector = (state: ApplicationState) => state.router.pathname;

export const basePathSelector = (state: ApplicationState) => {
    return state.router.pathname!
        .substring(0, state.router.pathname!.indexOf("accessGroups") + "accessGroups".length);
};
